import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Multiselect from 'react-widgets/lib/Multiselect';

import { querySelector } from '../../utils';

const propTypes = exact({
  name: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  /* eslint-disable react/no-unused-prop-types */
  data: PropTypes.object,
  equipment: PropTypes.array,
});

const defaultProps = {
  onChange: () => {},
  onAdd: () => {},
  onRemove: () => {},
};

export class EquipmentPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnToggle = this.handleOnToggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleOnFocus() {
    this.setState({
      open: true,
    });
  }

  handleOnToggle(open) {
    this.setState({
      open,
    });
  }

  handleChange(items, meta) {
    const { action, dataItem } = meta;

    this.props.onChange({
      target: {
        name: this.props.name,
        value: items,
      },
    });

    if (!dataItem) {
      return;
    }

    switch (action) {
      case 'insert':
        this.props.onAdd(dataItem);
        break;
      case 'remove':
        this.props.onRemove(dataItem);
        break;
      default:
        throw new Error(`invalid change action: ${action}`);
    }
  }

  render() {
    const { open } = this.state;
    return (
      <div>
        {
          /*
            The on mouse down prevents the 'onClick' from firing. This was toggling the dropdown
            twice. If you have a better way of prevent the double toggle by all means implement it.
          */
        }
        <Multiselect
          value={this.props.value}
          onChange={this.handleChange}
          data={this.props.equipment}
          open={open}
          onFocus={this.handleOnFocus}
          onToggle={this.handleOnToggle}
          onMouseDown={(e) => { e.preventDefault(); }}
          textField={(item) => { return `${item.equipment_number}`; }}
        />
      </div>
    );
  }
}

const GetAllEquipmentQuery = gql`
  query GetAllEquipment {
    all_equipment {
      edges {
        node {
         id
         equipment_number
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const equipment = querySelector(data, '$.all_equipment.edges[*].node', []);
  return {
    ...ownProps,
    data,
    equipment,
  };
};

const withData = graphql(GetAllEquipmentQuery, {
  props: marshallData,
  options: { fetchPolicy: 'network-only' },
});

EquipmentPicker.propTypes = propTypes;
EquipmentPicker.defaultProps = defaultProps;

export default withData(EquipmentPicker);
